import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    rank: [],
    keyward: "",
    local: [],
    industry: [],
    skill: [],
    searchedCheck: false,
};
const userSearchSlice = createSlice({
    name: 'companyUserSearch',
    initialState,
    reducers: {
        setSearchAction(state, action) {
            return state = action.payload;
        },
    },
});
//Actions
export const { setSearchAction, } = userSearchSlice.actions;
export default userSearchSlice;
